module.exports = __webpack_public_path__ + "img/statistic.3ad18905.svg";